import { Injectable } from "@angular/core";
import { AppModeEnum, AppState } from "@shared/app-state";
import { CustomerDataService } from './customer-data.service';
import { OrderOnBehalfService } from './order-on-behalf.service';

@Injectable({
	providedIn: 'root'
})
export class AftersalesService {

	constructor(
		private orderOnBehalfService: OrderOnBehalfService,
		private appState: AppState,
		private customerDataService: CustomerDataService
	) {
	}

	public async CheckAndPerformAftersalesFlow(token: string): Promise<IAftersalesData | undefined> {
		if (!token) {
			return;
		}

		let udm: IAftersalesData;

		try {
			const claims = this.decodeJwtPayload(token);

			udm = JSON.parse(claims);

			if (!udm.FlowType) {
				return;
			}

			udm.FlowType = AppModeEnum[udm.FlowType.toString().toLowerCase() as keyof typeof AppModeEnum];

			if (udm && udm.FlowType && (udm.FlowType === AppModeEnum.repair || udm.FlowType === AppModeEnum.substitution)) { //			udm.FlowType != AppModeEnum.default) {
				// if claims has crm ticket id
				this.appState.afterSalesCRMCaseNo.next(udm.CaseNumber);

				// if claims has repair or substitution
				this.appState.appMode.next(udm.FlowType);

				// if claims has serialnumber
				this.appState.afterSalesSerialNo.next(udm.SerialNumber);

				const customer = await this.customerDataService.getCustomerByCode(udm.ClientCustomerCode);
				await this.orderOnBehalfService.setCustomer(customer)
			}

			const data: IAftersalesData = {
				FlowType: udm?.FlowType ?? AppModeEnum.default,
				SerialNumber: udm?.SerialNumber ?? ''
			};

			return Promise.resolve(data);
		}
		catch (error) {
			console.log(error);
		}
		return
	}

	/** JWT payloads are base64url and often omit padding; decode as UTF-8. */
	private decodeJwtPayload(token: string): string {
		const base64Url = token.split('.')[1];
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
		const binary = atob(padded);
		const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
		return new TextDecoder().decode(bytes);
	}
}

export interface IAftersalesData {
	ClientCustomerCode?: string;
	CaseNumber?: string;
	FlowType: AppModeEnum;
	SerialNumber: string;
}